import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

var Toggle =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Toggle, _PureComponent);

  function Toggle() {
    _classCallCheck(this, Toggle);

    return _possibleConstructorReturn(this, _getPrototypeOf(Toggle).apply(this, arguments));
  }

  _createClass(Toggle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          on = _this$props.on,
          onClick = _this$props.onClick,
          onText = _this$props.onText,
          offText = _this$props.offText,
          size = _this$props.size,
          disabled = _this$props.disabled;
      return React.createElement("div", {
        className: "toggle".concat(size ? " toggle-".concat(size) : '', " toggle-").concat(on ? 'on' : 'off', " ").concat(disabled ? 'disabled' : 'clickable'),
        onClick: disabled ? null : onClick
      }, React.createElement("div", {
        className: "toggle-label"
      }, on ? onText : offText), React.createElement("div", {
        className: "toggle-switch"
      }));
    }
  }]);

  return Toggle;
}(PureComponent);

export { Toggle as default };
Toggle.propTypes = {
  on: PropTypes.bool,
  onClick: PropTypes.func,
  onText: PropTypes.string,
  offText: PropTypes.string,
  size: PropTypes.oneOf(['sm']),
  disabled: PropTypes.bool
};
Toggle.defaultProps = {
  onText: 'On',
  offText: 'Off',
  disabled: false
};